import TheGrid from '@/views/scorecard/objectives/grid'
import Edit from '@/views/scorecard/objectives/edit'
import Importer from '@/views/scorecard/objectives/import'

export default {
  path: '/scorecard/objectives',
  redirect: '/scorecard/objectives/index',
  name: 'scorecard_objectives',
  meta: {
    auth: {
      redirect: {
        name: 'scorecard_objectives.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Scorecard'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'scorecard_objectives.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'scorecard_objectives.create',
    component: Edit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'import',
    name: 'scorecard_objectives.import',
    component: Importer,
    meta: {
      auth: true,
      label: 'Importar'
    }
  }, {
    path: 'edit/:id',
    name: 'scorecard_objectives.edit',
    component: Edit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }]
}
